import { PxdAgEditGridDefaultColumnDef, PxdAgGridColumnTypes, PxdAgGridOptions, PxdAgGridSideBarOptions, PxdAgGridStatusBarOptions } from '@app/shared/aggrid/pxd-ag-grid-options';
import { PxdColumns } from '@app/shared/kendoui/grid/interfaces/pxd-columns';

export class ProjectTeamGridOptions implements PxdAgGridOptions {
  enableCharts = true;
  cellSelection = true;
  rowGroupPanelShow: 'always' | 'onlyWhenGrouping' | 'never' = 'always';
  editType: 'fullRow' = 'fullRow';
  defaultColDef = PxdAgEditGridDefaultColumnDef;
  statusBar = PxdAgGridStatusBarOptions;
  sideBar = PxdAgGridSideBarOptions;
  columnTypes = PxdAgGridColumnTypes;
  columnDefs = [];
}

export interface DefaultTeamsData {
  DefaultProjectTeamId?: number;
  Description?: string;
  AssetTeamId?: number;
  FunctionId?: number;
  ProgramManagerEmployeeId?: number;
  ProjectManagerEmployeeId?: number;
  ProjectControlAnalystEmployeeId?: number;
  ProjectEngineerEmployeeId?: number;
  ProjectTechEmployeeId?: number;
}

export const columns: PxdColumns[] = [
  {
    field: 'Description',
    title: 'Project Team',
    params: {
      type: 'string',
      display: true
    }
  },
  {
    field: 'AssetTeamCode',
    title: 'Asset Team',
    params: {
      type: 'dropdownlist',
      display: true,
      valueField: 'AssetTeamId' //used for filldown
    }
  },
  {
    field: 'FunctionDescription',
    title: 'Function',
    params: {
      type: 'dropdownlist',
      display: true,
      valueField: 'FunctionId' //used for filldown
    }
  },
  {
    field: 'ProgramManagerFullName',
    title: 'Program Manager',
    params: {
      type: 'dropdownlist',
      display: true,
      valueField: 'ProgramManagerEmployeeId' //used for filldown
    }
  },
  {
    field: 'ProjectManagerFullName',
    title: 'Project Manager',
    params: {
      type: 'dropdownlist',
      display: true,
      valueField: 'ProjectManagerEmployeeId' //used for filldown
    }
  },
  {
    field: 'ProjectControlAnalystFullName',
    title: 'Project Control Analyst',
    params: {
      type: 'dropdownlist',
      display: true,
      valueField: 'ProjectControlAnalystEmployeeId' //used for filldown
    }
  },
  {
    field: 'ProjectEngineerFullName',
    title: 'Project Engineer',
    params: {
      type: 'dropdownlist',
      display: true,
      valueField: 'ProjectEngineerEmployeeId' //used for filldown
    }
  },
  {
    field: 'ProjectTechFullName',
    title: 'Project Tech',
    params: {
      type: 'dropdownlist',
      display: true,
      valueField: 'ProjectTechEmployeeId' //used for filldown
    }
  }

];